module.exports = __webpack_public_path__ + "static/media/head_example.2efe969e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head_example.jpg
// module id = 2535
// module chunks = 2